import Backbone from 'backbone'
import template from './calendars-test.hbs'
import DateMultiSelector from 'scoreboard/components/date-multi-selector'
import DateTimeMultiSelector from 'scoreboard/components/date-time-multi-selector'
import CalendarControl from 'scoreboard/components/calendar-control'
import moment from 'moment'
import TimeInput from 'scoreboard/components/time-input'
import TimeControl from 'scoreboard/components/time-control'

var TestCalendarsView = Backbone.View.extend({

	className: 'admin table-hack display-layout admin-test-view admin-test-calendars',

	render: function () {
		this.$el.empty().append(template())

		let testCalendar = new CalendarControl({
			tooltip: false,
			initialValue: '1978-01-01'
		})
		this.$('.panel.calendar-selector-panel .panel-content').append(testCalendar.el)
		testCalendar.render()

		let testCalendarDisabledDates = new CalendarControl({
			tooltip: false,
			initialValue: '1978-03-01',
			dateValidator: d => {
				let m = moment(d)
				let y = m.year(1978)
				let f = 'MM-DD'

				// Mark January - June as disabled
				let start = moment('01-01', f).year(y).startOf('day')
				let end = moment('06-30', f).year(y).endOf('day')
				return m.isBefore(start) || m.isAfter(end)
			}
		})
		this.$('.panel.calendar-selector-panel-disabled-dates .panel-content')
			.append(testCalendarDisabledDates.el)
		testCalendarDisabledDates.render()

		new DateMultiSelector({
			el: this.$('[name=dateMultiSelector]'),
			dates: [moment('01-01-1978')]
		}).render()

		new DateTimeMultiSelector({
			el: this.$('[name=timeMultiSelector]'),
			times: [{
				hour: 8,
				minute: 33,
				second: 24,
				period: 'AM'
			}]
		}).render()

		new DateTimeMultiSelector({
			el: this.$('[name=dateTimeMultiSelector]'),
			times: [],
			// NOTE: The styling of this date+time multi selector will be off. We
			// aren't yet using it in the app so the styling hasn't been put in
			// yet for the sake of time.
			hasCalendarControl: true
		}).render()

		let timeControl12 = new TimeControl()
		this.$('.time-control-panel.12-hour.seconds .panel-content .time-control-container').append(timeControl12.el)
		timeControl12.render()
		this.$('.time-control-panel.12-hour.seconds button').click(() => {
			this.$('.time-control-panel.12-hour.seconds .time-result').text(JSON.stringify(timeControl12.getTime(), null, 2))
		})
		this.$('.time-control-panel.12-hour.seconds .time-result').text(JSON.stringify(timeControl12.getTime(), null, 2))

		let timeControl12NoSeconds = new TimeControl({
			hidingSeconds: true
		})
		this.$('.time-control-panel.12-hour.no-seconds .panel-content .time-control-container').append(timeControl12NoSeconds.el)
		timeControl12NoSeconds.render()
		this.$('.time-control-panel.12-hour.no-seconds button').click(() => {
			this.$('.time-control-panel.12-hour.no-seconds .time-result').text(JSON.stringify(timeControl12NoSeconds.getTime(), null, 2))
		})
		this.$('.time-control-panel.12-hour.no-seconds .time-result').text(JSON.stringify(timeControl12NoSeconds.getTime(), null, 2))

		let timeControl24 = new TimeControl({
			hour24: true
		})
		this.$('.time-control-panel.24-hour .panel-content .time-control-container').append(timeControl24.el)
		timeControl24.render()
		this.$('.time-control-panel.24-hour button').click(() => {
			this.$('.time-control-panel.24-hour .time-result').text(JSON.stringify(timeControl24.getTime(), null, 2))
		})
		this.$('.time-control-panel.24-hour .time-result').text(JSON.stringify(timeControl24.getTime(), null, 2))

		let timeControlPreset = new TimeControl({
			initialValue: {
				hour: 8,
				minute: 33,
				second: 24,
				period: 'AM'
			}
		})
		this.$('.time-control-panel.preset .panel-content .time-control-container').append(timeControlPreset.el)
		timeControlPreset.render()
		this.$('.time-control-panel.preset button').click(() => {
			this.$('.time-control-panel.preset .time-result').text(JSON.stringify(timeControlPreset.getTime(), null, 2))
		})
		this.$('.time-control-panel.preset .time-result').text(JSON.stringify(timeControlPreset.getTime(), null, 2))

		let timeControlInput12Hour = new TimeInput()
		this.$('.time-control-input-panel.12-hour .panel-content').append(timeControlInput12Hour.el)
		timeControlInput12Hour.render()

		let timeControlInput24Hour = new TimeInput({
			timeDisplayType: 'hour-24-seconds',
			dateTime: {
				time: {
					hour: 8,
					minute: 33,
					second: 24,
					period: 'AM'
				}
			}
		})
		this.$('.time-control-input-panel.24-hour .panel-content').append(timeControlInput24Hour.el)
		timeControlInput24Hour.render()

		let timeControlInputWithCal = new TimeInput({
			hasCalendarControl: true
		})
		this.$('.time-control-input-panel.with-cal .panel-content').append(timeControlInputWithCal.el)
		timeControlInputWithCal.render()


		return this
	}
})

export default TestCalendarsView
